/* tslint:disable */
/* eslint-disable */
/**
 * deliveryProviderPortal delivery-campaign-provider api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const PromotionFilterRules = {
        TYPE_OF_DISCOUNT_FREE_DELIVERY: 'type_of_discount_free_delivery',
        TYPE_OF_DISCOUNT_FREE_BASE_DELIVERY: 'type_of_discount_free_base_delivery',
        TYPE_OF_DISCOUNT_FULL_MENU: 'type_of_discount_full_menu',
        TYPE_OF_DISCOUNT_SELECTED_ITEMS: 'type_of_discount_selected_items',
        TYPE_OF_DISCOUNT_DOUBLE_DEAL: 'type_of_discount_double_deal',
        DISCOUNT_TARGETING_ALL_CUSTOMERS: 'discount_targeting_all_customers',
        DISCOUNT_TARGETING_NEW_CUSTOMERS: 'discount_targeting_new_customers',
        DISCOUNT_TARGETING_RETURNING_CUSTOMERS: 'discount_targeting_returning_customers',
        DISCOUNT_TARGETING_CHURNED_CUSTOMERS: 'discount_targeting_churned_customers',
        DISCOUNT_TARGETING_BEST_CUSTOMERS: 'discount_targeting_best_customers',
        DISCOUNT_VALUE_PERCENTAGE: 'discount_value_percentage',
        MAXIMUM_DISCOUNT_VALUE: 'maximum_discount_value',
        MINIMUM_ORDER_VALUE: 'minimum_order_value',
        NO_MINIMUM_ORDER_VALUE: 'no_minimum_order_value',
        NO_MAXIMUM_DISCOUNT_VALUE: 'no_maximum_discount_value',
        NO_DISCOUNT_VALUE_PERCENTAGE: 'no_discount_value_percentage',
        NO_RULE_APPLIED: 'no_rule_applied',
        SELECT_DISABLED: 'select_disabled',
        TYPE_OF_DISCOUNT_DOUBLE_DEAL_V2: 'type_of_discount_double_deal_v2',
        DOUBLE_DEAL_VALUE: 'double_deal_value',
        NO_DOUBLE_DEAL_VALUE: 'no_double_deal_value'
} as const;
export type PromotionFilterRules = typeof PromotionFilterRules[keyof typeof PromotionFilterRules];

